import { Routes } from '@angular/router';
import { ErrorPageComponent } from './error-page/error-page.component';
import { PageGuard } from './guards/page.guard';
import { serviciosGuard } from './guards/servicios.guard';
import { serviciosListadoGuard } from './guards/serviciosListado.guard';
import { destinosGuard } from './guards/destinos.guard';
import { Paso1Guard } from './guards/paso1.guard';
import { Paso2Guard } from './guards/paso2.guard';
import { Paso3Guard } from './guards/paso3.guard';
import { Paso4Guard } from './guards/paso4.guard';

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./web/home/home.component')
	},
	{
		path: 'destinos-peru',
		pathMatch: 'full',
		loadComponent: () => import('./web/destinos/listado/listado2.component')
	},
	{
		path: 'viajar-bus/:slug',
		pathMatch: 'full',
		loadComponent: () => import('./web/destinos/detalle/detalle.component'),
		canActivate: [destinosGuard]
	},
	{
		path: 'promociones',
		pathMatch: 'full',
		loadComponent: () => import('./web/promociones/promociones.component')
	},
	{
		path: 'servicios',
		pathMatch: 'full',
		loadComponent: () => import('./web/servicios/listado/listado.component'),
		canActivate: [serviciosListadoGuard]
	},
	{
		path: 'servicio/:slug',
		pathMatch: 'full',
		loadComponent: () => import('./web/servicios/detalle/detalle.component'),
		canActivate: [serviciosGuard]
	},
	{
		path: 'servicio-envios',
		pathMatch: 'full',
		// loadComponent: () => import('./web/encomiendas-1/encomiendas-1.component')
		loadComponent: () => import('./web/encomiendas/encomiendas.component')
	},
	// {
	// 	path: 'envio-encomiendas',
	// 	pathMatch: 'full',
	// 	loadComponent: () => import('./web/encomiendas-1/encomiendas-1.component')
	// },
	{
		path: 'servicio-envios/encomiendas-paquetes-mudanzas',
		pathMatch: 'full',
		loadComponent: () => import('./web/encomiendas-detalle/encomiendas-detalle.component')
	},
	{
		path: 'servicio-envios/delivery-contraentrega',
		pathMatch: 'full',
		loadComponent: () => import('./web/encomiendas-detalle-2/encomiendas-detalle.component')
	},
	{
		path: 'servicio-envios/transporte-terrestre-carga',
		pathMatch: 'full',
		loadComponent: () => import('./web/encomiendas-detalle-3/encomiendas-detalle.component')
	},
	{
		path: 'venta-buses-segunda-mano',
		pathMatch: 'full',
		loadComponent: () => import('./web/sellex/sellex.component')
	},
	{
		path: 'transporte-personal',
		pathMatch: 'full',
		loadComponent: () => import('./web/transporte-personal/transporte-personal.component')
	},
	{
		path: 'transporte-turistico',
		pathMatch: 'full',
		loadComponent: () => import('./web/transporte-turistico/transporte-turistico.component')
	},
	{
		path: 'recomendaciones-viajar',
		pathMatch: 'full',
		loadComponent: () => import('./web/info-viaje/info-viaje.component')
	},
	{
		path: 'contacto',
		pathMatch: 'full',
		loadComponent: () => import('./web/contacto/contacto.component')
	},
	{
		path: 'preguntas-frecuentes',
		pathMatch: 'full',
		loadComponent: () => import('./web/preguntas-frecuentes/preguntas-frecuentes.component')
	},
	{
		path: 'agencia-movil-bus',
		pathMatch: 'full',
		loadComponent: () => import('./web/nosotros/nosotros.component')
	},
	{
		path: 'pasajes-en-bus/paso1/:slug/:fechaida/:tramo',
		pathMatch: 'full',
		loadComponent: () => import('./ecommerce/paso1/paso1.component'),
		canActivate: [Paso1Guard]
	},
	{
		path: 'pasajes-en-bus/paso2/:slug/asientos/:tramo',
		pathMatch: 'full',
		loadComponent: () => import('./ecommerce/paso2/paso2.component'),
		canActivate: [Paso2Guard]
	},
	{
		path: 'pasajes-en-bus/paso3/:slug/registro-pasajeros',
		pathMatch: 'full',
		loadComponent: () => import('./ecommerce/paso3/paso3.component'),
		canActivate: [Paso3Guard]
	},
	{
		path: 'pasajes-en-bus/paso4/:slug/checkout',
		pathMatch: 'full',
		loadComponent: () => import('./ecommerce/paso4/paso4.component'),
		canActivate: [Paso4Guard]
	},
	// {
	// 	path: 'pasajes-en-bus/detalle-compra',
	// 	loadComponent: () => import('./ecommerce/detalle-compra/detalle-compra.component')
	// },
	{
		path: 'confirmacion-pago',
		pathMatch: 'full',
		loadComponent: () => import('./ecommerce/detalle-compra/detalle-compra.component')
	},
	{
		path: 'blog',
		pathMatch: 'full',
		loadComponent: () => import('./blog/articulos-blog/articulos-blog.component')
	},
	{
		path: 'blog/:slug',
		pathMatch: 'full',
		loadComponent: () => import('./blog/detalle-blog/detalle-blog.component')
	},
	{ path: 'page-not-found', component: ErrorPageComponent },
	{
		path: ':slug',
		pathMatch: 'full',
		loadComponent: () => import('./web/pages/pages.component'),
		canActivate: [PageGuard]
	},
	{ path: '**', component: ErrorPageComponent }
];
